export default __webpack_public_path__ + "static/berlin-df9960fb8b04e3cf328a1cb7b491997c.png";